import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import Carousel from '../../../../commonComponents/carousel/Carousel';
import JourneyProp from '../../propTypes/journeyProp';
import JourneyCarouselItem from './JourneyCarouselItem';
import JourneyStepProp from '../../propTypes/journeyStepProp';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import Anchor from '../../../../commonComponents/Anchor';

function JourneyCarousel(props) {
  const {
    t,
    journey,
    selected,
    onSelection,
    isShowingAll,
    onToggleShowAll,
    isEnrolled,
    onEnroll,
  } = props;
  const { loggedUser } = useContext(LoggedUserContext);
  const steps = journey.steps || [];
  const carouselReset = useRef(null);
  useEffect(
    () => {
      if (carouselReset.current) {
        const selectedStepIndex = steps.findIndex(
          s => selected && s._id === selected._id,
        );
        if (selectedStepIndex !== -1) {
          carouselReset.current.scrollToIndex(selectedStepIndex);
        } else {
          carouselReset.current.reset();
        }
      }
    },
    [selected],
  );

  return steps.length > 0 ? (
    <div
      className="m-portlet m-portlet--rounded m-portlet--rounded-force"
      style={{ position: 'relative' }}
    >
      {!isEnrolled && (
        <div className="enroll-overlay">
          <h2 className="enroll-title">{t('journey_enrollToday')}</h2>
          <p className="enroll-message">{t('journey_enrollMessage')}</p>
          {loggedUser && onEnroll ? (
            <button
              type="button"
              onClick={onEnroll}
              className="btn m-btn--pill btn-dynamic enroll-button"
            >
              {t('academy_enroll')}
            </button>
          ) : (
            <Anchor
              href={`/journey/${journey.slug}?open=true`}
              className="btn m-btn--pill btn-dynamic enroll-button"
              itemProp="url"
            >
              {t('academy_enroll')}
            </Anchor>
          )}
        </div>
      )}
      <div className="m-portlet__body course-container-body journey-overall-carousel-background">
        <hr className="middle-line" />
        <Carousel ref={carouselReset}>
          {steps.map((step, index) => (
            <JourneyCarouselItem
              isSequential={journey.isSequential}
              active={selected && selected._id === step._id}
              onClick={() => onSelection(step._id)}
              key={step._id}
              stepCount={steps.length}
              index={index}
              step={step}
            />
          ))}
        </Carousel>
        <button
          type="button"
          onClick={onToggleShowAll}
          className="landing-certification-browse btn m-btn--pill btn-dynamic"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          {isShowingAll ? (
            <>
              <i className="la la-close" />
              {t('landing_journey_close_btn')}
            </>
          ) : (
            <>
              <i className="fa fa-expand-arrows-alt" />
              {t('landing_journey_all_btn')}
            </>
          )}
        </button>
      </div>
    </div>
  ) : null;
}

JourneyCarousel.propTypes = {
  t: PropTypes.func.isRequired,
  journey: PropTypes.shape(JourneyProp.propType).isRequired,
  selected: PropTypes.shape(JourneyStepProp.propType).isRequired,
  onSelection: PropTypes.func.isRequired,
  isShowingAll: PropTypes.bool.isRequired,
  onToggleShowAll: PropTypes.func.isRequired,
  isEnrolled: PropTypes.bool.isRequired,
  onEnroll: PropTypes.func.isRequired,
};

export default translate(JourneyCarousel);
